import { z, zCoercedBoolean } from '@harvestiq/zod';
import { RmaLgmCommodityCodes, RmaLgmTypeCodes } from '@harvestiq/constants';
import { zCalendarDate, zDecimalNullable } from '@harvestiq/zod';

export const emailLgmQuoteRequestSchema = z.object({
  marketingMonths: z.array(z.coerce.number()),
  targetSalesEffectiveDate: zCalendarDate(),
  deductibles: z.array(z.coerce.number().int().min(0).max(150)),
  liveCattleTargetCwtPerHead: zDecimalNullable().optional(),
  feederCattleTargetCwtPerHead: zDecimalNullable().optional(),
  cornTargetBuPerHead: zDecimalNullable().optional(),
  commodityCode: z.nativeEnum(RmaLgmCommodityCodes),
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
  recipients: z.string().email().array().min(1),
  message: z.string().optional(),
  sendPreview: z.boolean().optional(),
  allowExternalRecipients: z.boolean().optional(),
  isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
  isVeteranFarmerRancher: zCoercedBoolean().optional(),
  beginningFarmerRancherCropYearCount: z.coerce
    .number()
    .int()
    .nullable()
    .optional(),
});

export type EmailLgmQuoteRequest = z.input<typeof emailLgmQuoteRequestSchema>;

export const emailLgmQuoteResponseSchema = z
  .object({
    sent: z.number(),
    data: z
      .object({
        filename: z.string(),
        fileUrl: z.string().url(),
      })
      .array(),
  })
  .or(
    z.object({
      errors: z
        .object({
          message: z.string(),
        })
        .array(),
    })
  );

export type EmailLgmQuoteResponse = z.infer<typeof emailLgmQuoteResponseSchema>;
